interface IDomainPrefix {
  host: string;
  domain: string;
  name: string;
  route: string;
}

export const DOMAIN_PREFIX: Record<number, IDomainPrefix> = {
  1: {
    host: 'cleartax.in/s',
    domain: 'cleartax.in',
    name: 'ClearTax',
    route: '/s',
  },
  2: {
    host: 'cleartax.com/sa',
    domain: 'cleartax.com/sa',
    name: 'ClearTax',
    route: '/sa',
  },
  3: {
    host: 'cleartax.com/usa',
    domain: 'cleartax.com/usa',
    name: 'ClearTax',
    route: '/usa',
  },
  4: {
    host: 'clear.in/s',
    domain: 'clear.in',
    name: 'Clear',
    route: '/s',
  },
  5: {
    host: 'clear.tech/blog',
    domain: 'clear.tech',
    name: 'ClearTech',
    route: '',
  },
  6: {
    host: 'cleartax.com/om',
    domain: 'cleartax.com/om',
    name: 'ClearTax',
    route: '/om',
  },
  7: {
    host: 'cleartax.com/bh',
    domain: 'cleartax.com/bh',
    name: 'ClearTax',
    route: '/bh',
  },
  8: {
    host: 'cleartax.com/ae',
    domain: 'cleartax.com/ae',
    name: 'ClearTax',
    route: '/ae',
  },
  9: {
    host: 'cleartax.com/fr',
    domain: 'cleartax.com/fr',
    name: 'ClearTax',
    route: '/fr',
  },
  10: {
    host: 'cleartax.com/es',
    domain: 'cleartax.com/es',
    name: 'ClearTax',
    route: '/es',
  },
  11: {
    host: 'cleartax.com/pl',
    domain: 'cleartax.com/pl',
    name: 'ClearTax',
    route: '/pl',
  },
  12: {
    host: 'cleartax.com/my',
    domain: 'cleartax.com/my',
    name: 'ClearTax',
    route: '/my',
  },
  13: {
    host: 'cleartax.com/sg',
    domain: 'cleartax.com/sg',
    name: 'ClearTax',
    route: '/sg',
  },
  14: {
    host: 'cleartax.com/de',
    domain: 'cleartax.com/de',
    name: 'ClearTax',
    route: '/de',
  },
  15: {
    host: 'cleartax.com/be',
    domain: 'cleartax.com/be',
    name: 'ClearTax',
    route: '/be',
  },
  16: {
    host: 'cleartax.com/ph',
    domain: 'cleartax.com/ph',
    name: 'ClearTax',
    route: '/ph',
  },
  17: {
    host: 'cleartax.com/th',
    domain: 'cleartax.com/th',
    name: 'ClearTax',
    route: '/th',
  },
  18: {
    host: 'cleartax.com/vi',
    domain: 'cleartax.com/vi',
    name: 'ClearTax',
    route: '/vi',
  },
  19: {
    host: 'cleartax.com/id',
    domain: 'cleartax.com/id',
    name: 'ClearTax',
    route: '/id',
  },
  20: {
    host: 'cleartax.com/eg',
    domain: 'cleartax.com/eg',
    name: 'ClearTax',
    route: '/eg',
  },
  21: {
    host: 'cleartax.com/au',
    domain: 'cleartax.com/au',
    name: 'ClearTax',
    route: '/au',
  },
  22: {
    host: 'cleartax.com/ro',
    domain: 'cleartax.com/ro',
    name: 'ClearTax',
    route: '/ro',
  },
  23: {
    host: 'cleartax.com/el',
    domain: 'cleartax.com/el',
    name: 'ClearTax',
    route: '/el',
  },
  24: {
    host: 'cleartax.com/kr',
    domain: 'cleartax.com/kr',
    name: 'ClearTax',
    route: '/kr',
  },
  25: {
    host: 'cleartax.com/jp',
    domain: 'cleartax.com/jp',
    name: 'ClearTax',
    route: '/jp',
  },
  26: {
    host: 'cleartax.com/nz',
    domain: 'cleartax.com/nz',
    name: 'ClearTax',
    route: '/nz',
  },
  27: {
    host: 'cleartax.com/al',
    domain: 'cleartax.com/al',
    name: 'ClearTax',
    route: '/al',
  },
  49: {
    host: 'cleartax.com/jo',
    domain: 'cleartax.com/jo',
    name: 'ClearTax',
    route: '/jo',
  },
  // 51 and 52 are environment-dependent for cleartax.com. 51 on Prod and 52 on QA.
  51: {
    host: 'cleartax.com',
    domain: 'cleartax.com',
    name: 'ClearTax',
    route: '/',
  },
  52: {
    host: 'cleartax.com',
    domain: 'cleartax.com',
    name: 'ClearTax',
    route: '/',
  },
};

export const domainCode = {
  cleartaxIn: 1,
  cleartaxSA: 2,
  cleartaxUSA: 3,
  clearIn: 4,
  ClearTech: 5,
  cleartaxOM: 6,
  cleartaxBH: 7,
  cleartaxAE: 8,
  cleartaxFR: 9,
  cleartaxES: 10,
  cleartaxPL: 11,
  cleartaxMY: 12,
  cleartaxSG: 13,
  cleartaxDE: 14,
  cleartaxBE: 15,
  cleartaxPH: 16,
  cleartaxTH: 17,
  cleartaxVI: 18,
  cleartaxID: 19,
  cleartaxEG: 20,
  cleartaxAU: 21,
  cleartaxRO: 22,
  cleartaxEL: 23,
  cleartaxKR: 24,
  cleartaxJP: 25,
  cleartaxNZ: 26,
  cleartaxAL: 27,
  cleartaxJO: 49,
  // Environment-dependent domain code for cleartax.com
  // In production: 51, In other environments (QA, dev, etc.): 52
  cleartaxCom: process.env.APP_ENV === 'production' ? 51 : 52,
};

export enum LANGUAGE_ENUMS {
  English = 'English',
  Hindi = 'Hindi',
  Arabic = 'Arabic',
  Marathi = 'Marathi',
  Tamil = 'Tamil',
  Telugu = 'Telugu',
  Kannada = 'Kannada',
  French = 'French',
  Spanish = 'Spanish',
  Polish = 'Polish',
  Malay = 'Malay',
  German = 'German',
  Thai = 'Thai',
  Indonesian = 'Indonesian',
  Egyptian = 'Egyptian',
  Romanian = 'Romanian',
  Greek = 'Greek',
  Vietnamese = 'Vietnamese',
  Filipino = 'Filipino',
  Dutch = 'Dutch',
  Korean = 'Korean',
  Japanese = 'Japanese',
  Albanian = 'Albanian',
}
export const LANGUAGE_CODE = {
  English: 1,
  Hindi: 2,
  Arabic: 3,
  Marathi: 4,
  Tamil: 5,
  Telugu: 6,
  Kannada: 7,
  French: 8,
  Spanish: 9,
  Polish: 10,
  Malay: 11,
  German: 12,
  Filipino: 13,
  Thai: 14,
  Vietnamese: 15,
  Indonesian: 16,
  Egyptian: 17,
  Romanian: 18,
  Greek: 19,
  Dutch: 20,
  Korean: 21,
  Japanese: 22,
  Albanian: 23,
};

export type TLANGUAGE_VALUE = keyof typeof LANGUAGE_VALUE;
export const LANGUAGE_VALUE = {
  1: 'English',
  2: 'Hindi',
  3: 'Arabic',
  4: 'Marathi',
  5: 'Tamil',
  6: 'Telugu',
  7: 'Kannada',
  8: 'French',
  9: 'Spanish',
  10: 'Polish',
  11: 'Malay',
  12: 'German',
  13: 'Filipino',
  14: 'Thai',
  15: 'Vietnamese',
  16: 'Indonesian',
  17: 'Egyptian',
  18: 'Romanian',
  19: 'Greek',
  20: 'Dutch',
  21: 'Korean',
  22: 'Japanese',
  23: 'Albanian',
};

export type TUrlPrefix = keyof typeof urlPrefix;
export const urlPrefix = {
  English: 'en',
  Hindi: 'hi',
  Marathi: 'mr',
  Tamil: 'ta',
  Telugu: 'te',
  Kannada: 'kn',
  Arabic: 'ar',
  French: 'fr',
  Spanish: 'es',
  Polish: 'pl',
  Malay: 'my',
  Singapore: 'sg',
  German: 'de',
  Belgium: 'be',
  Phillippines: 'ph',
  Thailand: 'th',
  Vietnam: 'vi',
  Indonesia: 'id',
  Egypt: 'eg',
  Australia: 'au',
  Romania: 'ro',
  Greece: 'el',
  Dutch: 'nl',
  Korean: 'ko',
  Japanese: 'ja',
  Albanian: 'sq',
  Filipino: 'ph',
};

export type TLangCodePrefix = keyof typeof langCodePrefix;
export const langCodePrefix = {
  en: 'English',
  hi: 'Hindi',
  mr: 'Marathi',
  ta: 'Tamil',
  te: 'Telugu',
  kn: 'Kannada',
  ar: 'Arabic',
  fr: 'French',
  es: 'Spanish',
  pl: 'Polish',
  my: 'Malay',
  de: 'German',
  be: 'Malay',
  ph: 'Filipino',
  th: 'Thai',
  vi: 'Vietnamese',
  id: 'Indonesian',
  eg: 'Egyptian',
  au: 'English',
  ro: 'Romanian',
  el: 'Greek',
  ko: 'Korean',
  ja: 'Japanese',
  sq: 'Albanian',
};

export const parentLanguageMap: Record<string, string> = {
  'cleartax.in/s': 'English',
  'cleartax.com/usa': 'English',
  'clear.in/s': 'English',
  'clear.tech/blog': 'English',
  'cleartax.com/sa': 'English',
  'cleartax.com/bh': 'English',
  'cleartax.com/om': 'English',
  'cleartax.com/ae': 'English',
  'cleartax.com/fr': 'French',
  'cleartax.com/es': 'Spanish',
  'cleartax.com/pl': 'Polish',
  'cleartax.com/my': 'Malay',
  'cleartax.com/sg': 'Malay',
  'cleartax.com/de': 'German',
  'cleartax.com/be': 'English',
  'cleartax.com/ph': 'Filipino',
  'cleartax.com/th': 'Thai',
  'cleartax.com/vi': 'Vietnamese',
  'cleartax.com/id': 'Indonesian',
  'cleartax.com/eg': 'Egyptian',
  'cleartax.com/au': 'English',
  'cleartax.com/ro': 'Romanian',
  'cleartax.com/el': 'Greek',
  'cleartax.com/kr': 'English',
  'cleartax.com/jp': 'English',
  'cleartax.com/nz': 'English',
  'cleartax.com/al': 'English',
  'cleartax.com/jo': 'English',
};
export type TCountryDomainCode = keyof typeof countryDomainCode;
export const countryDomainCode = {
  1: 'IN',
  2: 'sa',
  6: 'om',
  7: 'bh',
  8: 'ae',
  9: 'fr',
  10: 'es',
  11: 'pl',
  12: 'my',
  13: 'sg',
  14: 'de',
  15: 'be',
  16: 'ph',
  17: 'th',
  18: 'vi',
  19: 'id',
  20: 'eg',
  21: 'au',
  22: 'ro',
  23: 'el',
  24: 'kr',
  25: 'jp',
  26: 'nz',
  27: 'al',
  49: 'jo',
};

export const languageFlagLink = {
  English:
    'https://assets.clear.in/cleartax/images/1712030014_unitedstatesflag1icon.png',
  Hindi:
    'https://assets.clear.in/cleartax/images/1712030090_inindiaflagicon.png',
  Marathi:
    'https://assets.clear.in/cleartax/images/1712030090_inindiaflagicon.png',
  Tamil:
    'https://assets.clear.in/cleartax/images/1712030090_inindiaflagicon.png',
  Telugu:
    'https://assets.clear.in/cleartax/images/1712030090_inindiaflagicon.png',
  Kannada:
    'https://assets.clear.in/cleartax/images/1712030090_inindiaflagicon.png',
  Arabic:
    'https://assets.clear.in/cleartax/images/1712030291_svgviewerpngoutput1.png',
  French: 'https://assets.clear.in/cleartax/images/1689242452_frenchflag.webp',
  Spanish: 'https://assets.clear.in/cleartax/images/1689244119_spainflag.png',
  Polish: 'https://assets.clear.in/cleartax/images/1689244009_polandflag.png',
  Malay: 'https://assets.clear.in/cleartax/images/1689316023_malaysiaflag.jpg',
};

export const ARAB_COUNTRY_CODES = [
  domainCode.cleartaxSA,
  domainCode.cleartaxOM,
  domainCode.cleartaxBH,
  domainCode.cleartaxAE,
];

//TODO: finish this map for all domains and languages
export const domainMap: { [key: number]: string } = {
  12: 'MY',
};
export const languageMap: { [key: string]: string } = {
  English: 'en',
  Hindi: 'hi',
  Marathi: 'mr',
  Tamil: 'ta',
  Telugu: 'te',
  Kannada: 'kn',
  Arabic: 'ar',
  French: 'fr',
  Spanish: 'es',
  Polish: 'pl',
  Malay: 'ms',
  Singapore: 'sg',
  German: 'de',
  Belgium: 'be',
  Phillippines: 'ph',
  Thailand: 'th',
  Vietnam: 'vi',
  Indonesia: 'id',
  Egypt: 'eg',
  Australia: 'au',
  Romania: 'ro',
  Greece: 'el',
  Dutch: 'nl',
  Korean: 'ko',
  Japanese: 'ja',
  Albanian: 'sq',
  Filipino: 'ph',
};
